'use strict';

export default angular
  .module('maestro.services.data.monitoring', [
    'maestro.services.webcore'
  ])
  .service('MonitoringService', MonitoringService)
  .name;

function MonitoringService(webcore, $q) {

  /**
   * Retrieve call center service statuses
   * @param {number} locationId Location ID
   * @return {Promise}
   */
  this.getCallCenter = (locationId) => {
    return $q.when(
      webcore.services.professionalMonitoring.getCallCenter(locationId)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Retrieve call center alerts history
   * @param {number} locationId Location ID
   * @return {Promise}
   */
  this.getCallCenterAlerts = (locationId, params) => {
    return $q.when(
      webcore.services.professionalMonitoring.getCallCenterAlerts(locationId, params)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Update call center details
   * @param {Object} Call center object
   * @return {Promise}
   */
  this.updateCallCenter = (callCenter, locationId) => {
    return $q.when(
      webcore.services.professionalMonitoring.updateCallCenter(callCenter, locationId)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Create call center test
   * @param {number} locationId Location ID
   * @param {Object} testModel Test model with test details
   * @param {number} [testId] Test ID to modify specific test
   * @return {Promise}
   */
  this.createCallCenterTest = (locationId, testModel, testId) => {
    if (!locationId || locationId < 1 || isNaN(locationId)) {
      return $q.reject('Location ID is not specified!');
    }

    return $q.when(
      webcore.services.professionalMonitoring.createCallCenterTest(locationId, testModel, testId)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Cancel call center test
   * @param {number} locationId Location ID
   * @param {number} testId Specific test ID to cancel
   */
  this.cancelCallCenterTest = (locationId, testId) => {
    if (!locationId || locationId < 1 || isNaN(locationId)) {
      return $q.reject('Location ID is not specified!');
    }

    if (!testId || testId < 1 || isNaN(testId)) {
      return $q.reject('Test ID is not specified!');
    }

    return $q.when(
      webcore.services.professionalMonitoring.cancelCallCenterTest(locationId, testId)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };
}
